/**
 * **Pemilih tema** — terang · gelap · ikut sistem.
 *
 * ⚠️ Dipilih SENDIRI, bukan cuma mengikuti sistem. Ruang makan yang sama bisa remang pada malam
 * dan silau pada siang di terasnya; yang tahu kapan harus berganti adalah kasirnya, bukan setelan
 * OS yang dipasang sekali lalu tak pernah disentuh lagi.
 */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const KEY = 'osbpos.theme';
export type Theme = 'system' | 'light' | 'dark';

/** ⛔ Dipasang di `<html>`, bukan `<body>`: `color-scheme` harus mengenai scrollbar & form asli. */
export function applyTheme(t: Theme): void {
  const el = document.documentElement;
  if (t === 'system') el.removeAttribute('data-theme');
  else el.setAttribute('data-theme', t);
}

export function storedTheme(): Theme {
  const v = typeof localStorage === 'undefined' ? null : localStorage.getItem(KEY);
  return v === 'light' || v === 'dark' ? v : 'system';
}

export function ThemeSwitcher() {
  const { t } = useTranslation();
  const [theme, setTheme] = useState<Theme>(storedTheme);

  useEffect(() => { applyTheme(theme); }, [theme]);

  return (
    <label className="lang">
      <span className="lang-text">{t('common.theme')}</span>
      <select
        data-testid="theme"
        value={theme}
        onChange={(e) => {
          const v = e.target.value as Theme;
          localStorage.setItem(KEY, v);
          setTheme(v);
        }}
      >
        <option value="system">{t('common.themeSystem')}</option>
        <option value="light">{t('common.themeLight')}</option>
        <option value="dark">{t('common.themeDark')}</option>
      </select>
    </label>
  );
}
